import { AxiosRequest } from "../../../Url";
import { getRightsData } from "../../Tools/Tools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import { Prefixes } from "../../Tools/ProjectX";
import { getTableLayout } from "../../Tools/Requests";

export async function certGrid(grid: createGrid, source: createRecordSource, props, data) {
  source.onHandleRequest = handleTable(props);
  await source.open();
  const json = await getTableLayout({ module: Prefixes.progs, path: props.Path, sectionId: props.SectionID });
  if (json) {
    source.rights = getRightsData(json.Rights);
    grid.setColumns(parseColumns(json));
  } else grid.defaultColumns = true;
  await grid.setSource(source);
  if (props.RecordIndex) await grid.refreshSource(props.RecordIndex);
  await grid.updateGridSize();
}

function handleTable(props) {
  return (request) => {
    const params = new Map();
    params.set("prefix", "programs");
    params.set("comand", "HandleTable");
    params.set("Path", props.Path);
    params.set("SectionID", props.SectionID);
    return AxiosRequest(true, params, request);
  };
}
